import React, { useState, useEffect } from 'react';
import { Box, Grid, Typography, Container } from '@mui/material';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { getSubcategoriesByCategory } from '../services/Apis'; // <-- Import your API

const useQuery = () => {
  return new URLSearchParams(useLocation().search);
};

const ExamwiseBooks = () => {
  const query = useQuery();
  const cat = query.get('cat');
  const navigate = useNavigate();
  const { catname } = useParams();
  const [subCategory, setSubCategory] = useState([]);

  useEffect(() => {
    const fetchSubcategories = async () => {
      if (cat) {
        const subcats = await getSubcategoriesByCategory(cat);
        setSubCategory(subcats);
      }
    };
    fetchSubcategories();
  }, [cat]);

  return (
    <Container maxWidth="xl" sx={{ py: 5 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography
          variant="h3"
          sx={{
            fontWeight: 600,
            fontFamily: 'Poppins',
            color: '#CB4422',
            borderLeft: '4px solid #CB4422',
            paddingLeft: 1,
          }}
        >
          {catname}
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {subCategory.map((category, index) => (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }} sx={{ boxSizing: 'border-box' }} item key={index}>
            <Box
              sx={{
                position: 'relative',
                borderRadius: 2,
                overflow: 'hidden',
                boxShadow: 1,
                boxSizing: 'border-box',
                cursor: 'pointer',
                transition: 'transform 0.3s ease-in-out',
                '&:hover': {
                  transform: 'scale(1.03)',
                },
              }}
            >
              <img
                src={category.imageUrl || ''} // Use the correct field from your API
                alt={category.name}
                loading="lazy"
                onClick={() => navigate(`/filtered-books?subcat=${category.id}`)}
                style={{ width: '100%', height: '230px', objectFit: 'cover' }}
              />
              <Box
                sx={{
                  position: 'absolute',
                  bottom: 0,
                  width: '100%',
                  backgroundColor: 'primary.main',
                  textAlign: 'center',
                  py: 1.5,
                }}
              >
                <Typography
                  sx={{
                    color: '#fff',
                    fontFamily: 'Poppins',
                    fontWeight: 600,
                    fontSize: 14,
                  }}
                >
                  {category.name}
                </Typography>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Container>
  );
};

export default ExamwiseBooks;